import React, { useState } from "react";
import { motion, useScroll, useSpring, useTransform, useMotionValueEvent } from "framer-motion";
import { PineTree, MonkeyHead } from "./decor";
import { MILESTONES } from "./context";

// Camí vertical del bosc que es dibuixa a mesura que fas scroll (només desktop)
export default function ForestPath() {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 80, damping: 24, mass: 0.4 });
  const fillHeight = useTransform(progress, [0, 1], ["0%", "100%"]);
  const markerTop = useTransform(progress, [0, 1], ["0%", "100%"]);
  const [p, setP] = useState(0);
  useMotionValueEvent(progress, "change", (v) => setP(v));

  const n = MILESTONES.length;
  const stops = MILESTONES.map((_, i) => (i / (n - 1)) * 100);

  return (
    <div
      className="pointer-events-none fixed left-5 top-28 bottom-28 z-20 hidden w-10 lg:block"
      aria-hidden="true"
      data-testid="forest-path"
    >
      <div className="relative h-full w-full">
        {/* traç de fons */}
        <div className="absolute left-1/2 top-0 h-full w-[3px] -translate-x-1/2 rounded-full bg-kraft-dark" style={{ backgroundImage: "repeating-linear-gradient(#ddd2b6 0 8px, transparent 8px 16px)" }} />
        {/* traç pintat */}
        <motion.div
          className="absolute left-1/2 top-0 w-[3px] -translate-x-1/2 rounded-full bg-sage"
          style={{ height: fillHeight }}
        />

        {/* fites: pins */}
        {stops.map((top, i) => {
          const reached = p >= i / (n - 1) - 0.02;
          return (
            <div key={i} className="absolute left-1/2 -translate-x-1/2" style={{ top: `${top}%` }}>
              <motion.div
                animate={reached ? { scale: 1, opacity: 1 } : { scale: 0.7, opacity: 0.45 }}
                transition={{ type: "spring", stiffness: 260, damping: 14 }}
                className={reached ? "text-sage" : "text-kraft-dark"}
              >
                <PineTree className="h-7 w-4" />
              </motion.div>
            </div>
          );
        })}

        {/* el mico que recorre el camí */}
        <motion.div
          className="absolute left-1/2 z-10 -translate-x-1/2 -translate-y-1/2"
          style={{ top: markerTop }}
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-forest paper-shadow">
            <MonkeyHead className="h-5 w-5 text-kraft" />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
